import { isRejectedWithValue } from "@reduxjs/toolkit";
import { forceLogoutOn401 } from "../../redux/sessionLogout";

const sessionMiddleware = (store) => (next) => (action) => {
  if (isRejectedWithValue(action)) {
    // Login thunk: API body may contain `status: 401` without HTTP 401 — don’t auto-logout.
    if (
      String(action.type || "").includes("auth/login") ||
      String(action.type || "").includes("auth/forgotPassword")
    ) {
      return next(action);
    }

    const httpStatus =
      action.payload?.httpStatus ??
      action.payload?.originalStatus ??
      action.payload?.status;

    if (httpStatus === 401) {
      console.warn("401 Unauthorized — logging out");
      forceLogoutOn401(store);
    }
  }

  return next(action);
};

export default sessionMiddleware;
